/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { NgModule, ModuleWithProviders, SkipSelf, Optional } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { ShivaGNVertSecuredConfiguration, ShivaGNVertSecuredConfigurationParams } from './shiva-gn-vert-secured-configuration';

import { FilesStorageService } from './services/files-storage.service';
import { GeneralParametersService } from './services/general-parameters.service';
import { OnboardingService } from './services/onboarding.service';
import { KpiPerfEnergyService } from './services/kpi-perf-energy.service';
import { DafService } from './services/daf.service';
import { LoginService } from './services/login.service';
import { AdministrationRoleService } from './services/administration-role.service';
import { ReportingService } from './services/reporting.service';
import { AlarmsService } from './services/alarms.service';
import { MapService } from './services/map.service';
import { StationService } from './services/station.service';
import { CliproService } from './services/clipro.service';
import { TransactionAcquisitionService } from './services/transaction-acquisition.service';
import { PriceService } from './services/price.service';
import { TransactionsService } from './services/transactions.service';
import { PersonalSpaceService } from './services/personal-space.service';
import { ApiService } from './services/api.service';
import { TicketingService } from './services/ticketing.service';
import { LngService } from './services/lng.service';
import { DashboardGnlService } from './services/dashboard-gnl.service';
import { ComputedTagsFunctionsService } from './services/computed-tags-functions.service';
import { SitesConfigurationService } from './services/sites-configuration.service';
import { MadicService } from './services/madic.service';
import { GirService } from './services/gir.service';
import { InformationMessagesService } from './services/information-messages.service';
import { PushNotificationService } from './services/push-notification.service';
import { StatisticsService } from './services/statistics.service';
import { OnboardingSubscriptionService } from './services/onboarding-subscription.service';
import { SitesManagementService } from './services/sites-management.service';
import { SubscriptionsService } from './services/subscriptions.service';
import { AuthSupportsRequestService } from './services/auth-supports-request.service';
import { SubscriptionsReportService } from './services/subscriptions-report.service';
import { AuthorizationSupportsService } from './services/authorization-supports.service';
import { ExposedApiService } from './services/exposed-api.service';
import { SubscriptionContactsService } from './services/subscription-contacts.service';
import { TagService } from './services/tag.service';
import { ApplicationsService } from './services/applications.service';
import { EwonReferenceService } from './services/ewon-reference.service';

/**
 * Module that provides all services and configuration.
 */
@NgModule({
  imports: [],
  exports: [],
  declarations: [],
  providers: [
    FilesStorageService,
    GeneralParametersService,
    OnboardingService,
    KpiPerfEnergyService,
    DafService,
    LoginService,
    AdministrationRoleService,
    ReportingService,
    AlarmsService,
    MapService,
    StationService,
    CliproService,
    TransactionAcquisitionService,
    PriceService,
    TransactionsService,
    PersonalSpaceService,
    ApiService,
    TicketingService,
    LngService,
    DashboardGnlService,
    ComputedTagsFunctionsService,
    SitesConfigurationService,
    MadicService,
    GirService,
    InformationMessagesService,
    PushNotificationService,
    StatisticsService,
    OnboardingSubscriptionService,
    SitesManagementService,
    SubscriptionsService,
    AuthSupportsRequestService,
    SubscriptionsReportService,
    AuthorizationSupportsService,
    ExposedApiService,
    SubscriptionContactsService,
    TagService,
    ApplicationsService,
    EwonReferenceService,
    ShivaGNVertSecuredConfiguration
  ],
})
export class ShivaGNVertSecuredModule {
  static forRoot(params: ShivaGNVertSecuredConfigurationParams): ModuleWithProviders<ShivaGNVertSecuredModule> {
    return {
      ngModule: ShivaGNVertSecuredModule,
      providers: [
        {
          provide: ShivaGNVertSecuredConfiguration,
          useValue: params
        }
      ]
    }
  }

  constructor( 
    @Optional() @SkipSelf() parentModule: ShivaGNVertSecuredModule,
    @Optional() http: HttpClient
  ) {
    if (parentModule) {
      throw new Error('ShivaGNVertSecuredModule is already loaded. Import in your base AppModule only.');
    }
    if (!http) {
      throw new Error('You need to import the HttpClientModule in your AppModule! \n' +
      'See also https://github.com/angular/angular/issues/20575');
    }
  }
}
